import { Paragraph, Text, Spacer, Button, BUTTON_TYPES } from '@zillow/constellation';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { trackGAMortgageEvent } from '../analytics';
import { OUTCOME } from '../constants';
import {
    getCreditScoreArticleUrl,
    getDownPaymentAssistanceUrl,
    getPrequalUrl,
    getZGMICustomQuoteUrl,
    getPayOffDebtsGuideUrl,
} from '../url';

const CONTENT = {
    [OUTCOME.ZHL_PREQUAL]: {
        description: 'Take the next step to verify your budget by getting pre-qualified.',
        ctaText: 'Get pre-qualified',
        getUrl: getPrequalUrl,
    },
    [OUTCOME.ZGMI_CQ]: {
        description: 'Compare rates from multiple lenders, all in one place.',
        ctaText: 'See today’s rates',
        getUrl: getZGMICustomQuoteUrl,
    },
    [OUTCOME.LOW_CREDIT]: {
        description: 'Building your credit score could help you qualify for a loan.',
        ctaText: 'Learn more',
        getUrl: getCreditScoreArticleUrl,
    },
    [OUTCOME.LOW_DOWN_PAYMENT]: {
        description: 'Down payment assistance can help you lower the amount you need to save for a down payment.',
        ctaText: 'Learn more',
        getUrl: getDownPaymentAssistanceUrl,
    },
    [OUTCOME.HIGH_DEBT]: {
        description: 'Paying off your debts could help you qualify for a loan.',
        ctaText: 'Learn more',
        getUrl: getPayOffDebtsGuideUrl,
    },
};

const PrimaryCta = ({ outputs, ...restProps }) => {
    useEffect(() => {
        if (outputs.outcome) {
            const { ctaText } = CONTENT[outputs.outcome];
            trackGAMortgageEvent('Budget Calculator: Impression', `Calculator Primary CTA ${ctaText}`);
        }
    }, [outputs.outcome]);

    if (!outputs.outcome) {
        return null;
    }
    const { description, ctaText, getUrl } = CONTENT[outputs.outcome];
    const ctaHref = getUrl(outputs);

    return (
        <Spacer marginX="md" {...restProps}>
            <Text fontType="bodyHeading" marginTop="sm">
                What's next?
            </Text>
            <Paragraph fontType="bodySmall">{description}</Paragraph>
            <Button
                as="a"
                href={ctaHref}
                onClick={() => trackGAMortgageEvent('Budget Calculator: Click', `Calculator Primary CTA "${ctaText}"`)}
                buttonType={BUTTON_TYPES.primary}
                marginTop="md"
                fluid>
                {ctaText}
            </Button>
        </Spacer>
    );
};

PrimaryCta.propTypes = {
    outputs: PropTypes.object,
};

export default PrimaryCta;
